module.exports = __webpack_public_path__ + "img/tagline-img.f65b280f.png";